import { render, staticRenderFns } from "./AddStaff.vue?vue&type=template&id=0dba4e59&scoped=true&"
import script from "./AddStaff.vue?vue&type=script&lang=js&"
export * from "./AddStaff.vue?vue&type=script&lang=js&"
import style0 from "./AddStaff.vue?vue&type=style&index=0&id=0dba4e59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dba4e59",
  null
  
)

export default component.exports